import { showContextualLoader, hideContextualLoader, showContextualError } from "../redux/slices/contextualLoaderSlice";
import { store } from "../redux/store";
import { resetUserGesture } from "./userGesture";

const pendingApis = new Set();
const successfulApis = new Set();

export const contextualLoaderTrigger = {
  "/": {
    onClick: {
      message: "Verifying Your Mobile Number...",
      apis: ["customers/customer-login-byMsg91"],
    },
  },
  "/enter-otp": {
    onClick: {
      message: "Verifying OTP...",
      apis: ["customers/verify-otp", "step/next-step"], //if we need to wait untile multiple API response
    },
  },
  "/home": {
    onLoad: {
      message: "Please wait...",
      apis: ["customers/dashboard", "step/next-step"],
      apiBasedMessage: {
        //localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
        "customers/dashboard": "Please wait...",
        "customers/feedback": "Submitting your feedback...",
      },
    },
    onClick: {
      message: "Please wait...",
      apis: ["step/next-step"],
    },
  },
  "/enter-your-pan": {
    onClick: {
      message: "Verifying your PAN…",
      apis: ["customer_onboarding/pan-verification"],
    },
  },
  "/pan-verify": {
    onClick: {
      apis: ["customer_onboarding/pan-confirmation", "step/next-step"],
      message: "Submitting PAN details…",
    },
  },
  "/payment-mode": {
    onClick: {
      apis: ["customers/incompleteDetailsUpdate", "step/next-step"],
      message: "Saving your salary mode…",
    },
  },
  "/company-name": {
    onClick: {
      apis: ["customers/incompleteDetailsUpdate", "/step/next-step"],
      message: "Saving your employment details…",
    },
  },
  "/salary-date": {
    onClick: {
      apis: ["/customers/incompleteDetailsUpdate", "step/next-step"],
      loaderType: "bre",
      shouldWait: true,
    },
  },
  "/select-loan": {
    onLoad: {
      message: "Almost there, Please standby...",
      apis: ["loanapply/ramfincorp_api/payday_emi_loan_list_view", "step/next-step"],
    },
  },
  "/loan-approval": {
    onLoad: {
      message: "Completing your loan setup...",
      apis: ["customer_onboarding/approval-viewV2", "step/next-step"],
    },
    onClick: {
      message: "Processing your loan details...",
      apis: ["crm/paydayToEmiConversion", "customers/incompleteDetailsUpdate", "step/next-step"],
    },
  },
  "/employment-details": {
    onClick: {
      message: "Saving your employment information…",
      apis: ["customers/incompleteDetailsUpdate", "step/next-step"],
    },
  },
  "/loan-purpose": {
    onClick: {
      message: "Saving your loan purpose...",
      apis: ["customers/incompleteDetailsUpdate", "step/next-step"],
    },
  },
  "/enter-name": {
    onClick: {
      message: "Verifying your email...",
      apis: ["customer_onboarding/onboardUserEmail", "step/next-step"],
    },
  },
  "/reference-details": {
    onClick: {
      message: "Adding your references…",
      apis: ["customer_onboarding/reference", "step/next-step"],
    },
  },
  "/enter-aadhar": {
    onLoad: {
      message: "We're almost there, hang tight!",
      apis: ["common/aadhar-status", "step/next-step"],
    },
    onClick: {
      message: "Submitting Aadhaar details…",
      apis: ["customer_onboarding/aadhar-verification-generate-otp", "customer_onboarding/aadhar-verification-verify-otp", "customer_onboarding/aadhar-verification-initiate-digilocker", "step/next-step"],
      apiBasedMessage: {
        "customer_onboarding/aadhar-verification-generate-otp": "Validating Aadhar information…",
        "customer_onboarding/aadhar-verification-verify-otp": "Aadhar verification in progress…",
        "customer_onboarding/aadhar-verification-initiate-digilocker": "Aadhar verification in progress…",
      },
    },
  },
  "/re-kyc": {
    onLoad: {
      message: "We're almost there, hang tight!",
      apis: ["common/aadhar-status", "step/next-step"],
    },
    onClick: {
      message: "Submitting Aadhaar details…",
      apis: ["customer_onboarding/aadhar-verification-generate-otp", "customer_onboarding/aadhar-verification-verify-otp", "customer_onboarding/aadhar-verification-initiate-digilocker", "step/next-step"],
      apiBasedMessage: {
        "customer_onboarding/aadhar-verification-generate-otp": "Validating Aadhar information…",
        "customer_onboarding/aadhar-verification-verify-otp": "Aadhar verification in progress…",
        "customer_onboarding/aadhar-verification-initiate-digilocker": "Aadhar verification in progress…",
      },
    },
  },
  "/re-kyc-confirm-address": {
    onLoad: {
      message: "Confirming your address, please wait...",
      apis: ["loanapply/ramfincorp_api/payday_emi_loan_list_view", "step/next-step"],
    },
  },
  "/selfie-verification": {
    onClick: {
      message: "Uploading your selfie…",
      apis: ["customer_onboarding/selfie_liveness"],
    },
  },
  "/bank-details": {
    onLoad: {
      message: "Loading bank form...",
      apis: ["step/next-step"],
    },
    onClick: {
      message: "Verifying your bank details…",
      apis: ["customer-bank-account/bank-details", "step/next-step"],
    },
  },
  "/bank-list": {
    onLoad: {
      message: "Fetching bank list...",
      apis: ["customer-bank-account?", "step/next-step"],
    },
    onClick: {
      message: "Verifying your bank details…",
      apis: ["customer-bank-account/confirm", "step/next-step"],
    },
  },
  "/emandate": {
    onClick: {
      message: "Validating your mandate details…",
      apis: ["customer_onboarding/set-emandateV2", "customer_onboarding/penny-flow?", "customer_onboarding/penny-drop", "step/next-step"],
      apiBasedMessage: {
        "customer_onboarding/set-emandateV2": "Validating your mandate details…",
        "customer_onboarding/penny-flow?": "Checking your account eligibility…",
        "customer_onboarding/penny-drop": "Checking your account eligibility…",
      },
    },
  },
  "/term-condition": {
    onLoad: {
      message: "Preparing your KFS document...",
      apis: ["customer_onboarding/kfs-payday", "customer_onboarding/kfs-emi", "step/next-step"],
    },
    onClick: {
      message: "Saving your KFS agreement...",
      apis: ["customer_onboarding/kfs-facts-acceptance", "step/next-step"],
    },
  },
  // "/confirm-details": {
  //   onLoad: {
  //     message: "Opening your loan form…",
  //     apis: ["customers/one-page"],
  //   },
  //   onClick: {
  //     message: "Almost done! Final touches on your loan...",
  //     apis: ["customers/check-repeat-case/", "step/next-step"],
  //   }
  // },
};

const isUrlMatch = (array, url) => array?.some((str) => url.includes(str));

const loaderMsg = (array, url) => {
  let bestMatch = "";
  for (const key in array?.apiBasedMessage) {
    if (url.includes(key) && key.length > bestMatch.length) {
      bestMatch = key;
    }
  }
  return bestMatch ? array?.apiBasedMessage[bestMatch] : array.message;
};

export function handleApiStart(url, userGesture) {
  const cfg = contextualLoaderTrigger[window.location?.pathname];
  if (typeof cfg !== "object") return;
  const type = Object.keys(cfg).find((t) => {
    if (userGesture && t === "onLoad") {
      return false; // skip onLoad if userGesture is true
    }
    return isUrlMatch(cfg[t]?.apis, url);
  });
  if (!cfg[type]) return;
  pendingApis.add(url);
  if (type === "onClick" && !userGesture) {
    return; // skip loader if API wasn’t triggered by a click
  }
  store.dispatch(showContextualLoader({ message: loaderMsg(cfg[type], url), ...(cfg[type].loaderType && { loaderType: cfg[type].loaderType }) }));
}

// 🔹 On request success
export function handleApiSuccess(url, delay = 100) {
  let cfg = contextualLoaderTrigger[window.location?.pathname];
  if (typeof cfg !== "object") return;
  let type = Object.keys(cfg).find((t) => isUrlMatch(cfg[t]?.apis, url));
  if (!type) {
    pendingApis.clear();
    resetUserGesture();
    return false;
  }
  successfulApis.add(url);
  pendingApis.delete(url);
  if (cfg[type].shouldWait) {
    return false;
  }
  if (cfg[type]?.apis?.length > 1) {
    const allDone = cfg[type].apis.every((dep) => successfulApis.has(dep));
    if (allDone) {
      handlehideContextualLoader(delay);
      successfulApis.clear();
    }
    let interval = setInterval(() => {
      if (!store.getState()?.contextualLoader?.error && window.navigator.onLine && pendingApis.size === 0) {
        if (contextualLoaderTrigger[window.location?.pathname]) {
          handlehideContextualLoader(delay);
        }
        successfulApis.clear();
        clearInterval(interval);
        resetUserGesture();
      }
      if (store.getState()?.contextualLoader?.error) {
        clearInterval(interval);
      }
    }, 500);
  } else {
    setTimeout(() => {
      handlehideContextualLoader(delay);
      successfulApis.clear();
    }, delay);
  }
}

// 🔹 On request error
export function handleApiError(url, error) {
  let cfg = contextualLoaderTrigger[window.location?.pathname];
  if (typeof cfg !== "object") return;
  const type = Object.keys(cfg).find((t) => isUrlMatch(cfg[t]?.apis, url));
  if (contextualLoaderTrigger[type] !== undefined) {
    cfg = Object.values(contextualLoaderTrigger[type]).find((c) => Array.isArray(c.apis) && c.apis.includes(url));
  }
  if (!type) return;
  pendingApis.delete(url);
  if (error?.status === 404) {
    handlehideContextualLoader();
    return;
  }

  store.dispatch(
    showContextualError({
      message: error?.response?.data?.message || "Something went wrong",
      errorType: !error?.response ? "network" : "api",
      statusCode: error?.response?.status || error?.status || error?.statusCode,
    }),
  );
}

export const handleShowContextualLoader = (message = "Please wait...") => {
  store.dispatch(showContextualLoader({ message }));
};

export const handlehideContextualLoader = (delay = 500) => {
  let timer = setTimeout(() => {
    store.dispatch(hideContextualLoader());
    clearTimeout(timer);
  }, delay);
};

export const showManualContextualLoader = (message = "", delay = 500) => {
  handleShowContextualLoader(message);
  handlehideContextualLoader(delay);
};

window.addEventListener(
  "online",
  () => {
    if (store.getState()?.contextualLoader?.loading || store.getState()?.contextualLoader?.error) {
      handlehideContextualLoader();
    }
  },
  true,
);

window.addEventListener(
  "offline",
  () => {
    store.dispatch(
      showContextualError({
        loading: true,
        message: "Network error. Please check your internet connection...",
        errorType: "network",
      }),
    );
  },
  true,
);
